module.exports = __webpack_public_path__ + "img/gray-2.8a0dc35c.svg";